import { Component, output } from '@angular/core';

@Component({
  selector: 'confirmation-dialog',
  template: `
    <div
      class="modal"
      role="dialog"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <a class="close" aria-label="Cerrar" role="button" (click)="close()">
        Cerrar
      </a>
      <h1 id="dialog-title">Eliminar propuestas</h1>
      <p id="dialog-description">
        Está editando datos sensibles, si continúa con los cambios todas las
        propuestas generadas anteriormente serán eliminadas.
      </p>
      <div class="modalActions">
        <button class="secondary" (click)="close()">Cancelar</button>
        <button class="primary" (click)="confirm()">Eliminar</button>
      </div>
    </div>
  `,
  styleUrls: ['../new-standard-quote.component.scss'],
})
export class ConfirmationDialog {
  closed = output<boolean>();
  constructor() {}

  close() {
    this.closed.emit(false);
  }

  confirm() {
    this.closed.emit(true);
  }
}
